export const ALL_GRADES = Array.from({ length: 10 }, (_, i) => String(i + 3));

// Grades the admin has opened for this board (all of them when unknown).
export const gradesFor = (boards, boardName) =>
  (boards || []).find(b => b.name === boardName)?.classes || ALL_GRADES;
